/**
 * get the value of a CSS variable for the current active satellite
 * ```
 * // example
 * getStyleVar('--theme-font-size') // '14px'
 * ```
 */
export const getStyleVar = (styleVariable = '') => {
  return getComputedStyle(document.documentElement)
    ?.getPropertyValue(styleVariable)?.trim();
};

export const setStyleVar = (styleVariable = '', value = '') => {
  document.documentElement.style.setProperty(styleVariable, value);
};

/**
 * Example usage:
 *
 * ```
 * // Example 1: Relative path
 * const cssUrlValue = "url('img/demo/demo-fav-icon.ico')";
 * getCssUrlArgument(cssUrlValue); // returns "img/demo/demo-fav-icon.ico";
 *
 * // Example 2: External URL
 * const externalUrl = "url('https://example.com')";
 * getCssUrlArgument(externalUrl); // returns "https://example.com"
 *
 * // Example 3: Optional LOCATION_ORIGIN for satellite routes such as /privacy
 * const satelliteRoute = "url('LOCATION_ORIGIN/privacy')";
 * getCssUrlArgument(satelliteRoute); // e.g. returns "https://demo.content2classroom.com/privacy"
 * ```
 */
export const getCssUrlArgument = (cssUrlValue = '') => {
  if (!cssUrlValue || typeof cssUrlValue !== 'string') {
    return '';
  }
  const pattern = /'([^']*)'/;
  const extractedUrl = cssUrlValue.match(pattern)?.[1] || '';

  // Replace LOCATION_ORIGIN with window.location.origin
  return extractedUrl.replace(/LOCATION_ORIGIN/g, window.location.origin);
};

export const isWhiteStyleColor = (str) => {
  return typeof str === 'string' && (
    str.startsWith('white') ||
    str.startsWith('#fff') ||
    str.includes('255, 255, 255')
  );
};
